import { TYPOGRAPHY } from './Typographys';

export const TC_CONFIG = [
  {
    heading: {
      text: 'About the Website',
      className: '!font-semibold',
      type: TYPOGRAPHY.SUBTITLE,
    },
    description: {
      text: [
        '(a) Welcome to surpassin.com (Website). The Website provides Personal Development, Coaching, Goal Setting, DISC personality profiling, Vision Board creation, and Strengths/Weaknesses finder (Services).',
        '(b) The Website is operated by SurpasIn Pty Ltd (ACN 681516567). Access to and use of the Website, or any of its associated Products or Services, is provided by SurpasIn Pty Ltd. Please read these terms and conditions (Terms) carefully. By using, browsing and/or reading the Website, you signify that you have read, understood, and agree to be bound by the Terms. If you do not agree with the Terms, you must cease usage of the Website or any of the Services immediately.',
        '(c) SurpasIn Pty Ltd reserves the right to review and change any of the Terms by updating this page at its sole discretion. When SurpasIn Pty Ltd updates the Terms, it will use reasonable endeavours to provide you with notice of updates to the Terms. Any changes to the Terms take immediate effect from the date of their publication. Before you continue, we recommend you keep a copy of the Terms for your records.',
      ],
      className: '!font-normal',
      type: TYPOGRAPHY.PARA,
    },
  },
  {
    heading: {
      text: 'Acceptance of the Terms',
      className: '!font-semibold',
      type: TYPOGRAPHY.SUBTITLE,
    },
    description: {
      text: 'You accept the Terms by remaining on the Website. You may also accept the Terms by clicking to accept or agree to the Terms where this option is made available to you by SurpasIn Pty Ltd in the user interface.',
      className: '!font-normal',
      type: TYPOGRAPHY.PARA,
    },
  },
  {
    heading: {
      text: 'Subscription to use the Services',
      className: '!font-semibold',
      type: TYPOGRAPHY.SUBTITLE,
    },
    description: {
      text: [
        '(a) In order to access the Services, you must first purchase a subscription through the Website (Subscription) and pay the applicable fee for the selected Subscription (Subscription Fee).',
        '(b) In purchasing the Subscription, you acknowledge and agree that it is your responsibility to ensure that the Subscription you elect to purchase is suitable for your use.',
        '(c) Once you have purchased the Subscription, you will then be required to register for an account through the Website before you can access the Services (Account).',
        '(d) As part of the registration process, or as part of your continued use of the Services, you may be required to provide personal information about yourself (such as identification or contact details), including:',
        '(i) Email address',
        '(ii) Preferred username',
        '(iii) Mailing address',
        '(iv) Telephone number',
        '(v) Password',
        '(vi) Strengths, Weaknesses, Goals, Personality Profiling and Vision Board creation',
        '(e) You warrant that any information you give to SurpasIn Pty Ltd in the course of completing the registration process will always be accurate, correct and up to date.',
        '(f) Once you have completed the registration process, you will be a registered member of the Website (Member) and agree to be bound by the Terms. As a Member you will be granted immediate access to the Services from the time you have completed the registration process until the subscription period expires (Subscription Period).',
        '(g) You may not use the Services and may not accept the Terms if:',
        '(i) you are not of legal age to form a binding contract with SurpasIn Pty Ltd; or',
        '(ii) you are a person barred from receiving the Services under the laws of Australia or other countries including the country in which you are resident or from which you use the Services.',
      ],
      className: '!font-normal',
      type: TYPOGRAPHY.PARA,
    },
  },
  {
    heading: {
      text: 'Your obligations as a Member',
      className: '!font-semibold',
      type: TYPOGRAPHY.SUBTITLE,
    },
    description: {
      text: [
        '(a) As a Member, you agree to comply with the following:',
        '(i) you will use the Services only for purposes that are permitted by:',
        '(A) the Terms; and',
        '(B) any applicable law, regulation or generally accepted practices or guidelines in the relevant jurisdictions;',
        '(ii) you have the sole responsibility for protecting the confidentiality of your password and/or email address. Use of your password by any other person may result in the immediate cancellation of the Services;',
        '(iii) any use of your registration information by any other person, or third parties, is strictly prohibited. You agree to immediately notify SurpasIn Pty Ltd of any unauthorised use of your password or email address or any breach of security of which you have become aware;',
        '(iv) access and use of the Website is limited, non-transferable and allows for the sole use of the Website by you for the purposes of SurpasIn Pty Ltd providing the Services;',
        '(v) you will not use the Services or the Website in connection with any commercial endeavours except those that are specifically endorsed or approved by the management of SurpasIn Pty Ltd;',
        '(vi) you will not use the Services or Website for any illegal and/or unauthorised use which includes collecting email addresses of Members by electronic or other means for the purpose of sending unsolicited email or unauthorised framing of or linking to the Website;',
        '(vii) you agree that commercial advertisements, affiliate links, and other forms of solicitation may be removed from the Website without notice and may result in termination of the Services. Appropriate legal action will be taken by SurpasIn Pty Ltd for any illegal or unauthorised use of the Website; and',
        '(viii) you acknowledge and agree that any automated use of the Website or its Services is prohibited.',
      ],
      className: '!font-normal',
      type: TYPOGRAPHY.PARA,
    },
  },
  {
    heading: {
      text: 'Payment',
      className: '!font-semibold',
      type: TYPOGRAPHY.SUBTITLE,
    },
    description: {
      text: [
        '(a) All payments made in the course of your use of the Services are made using Stripe. In using the Website, the Services or when making any payment in relation to your use of the Services, you warrant that you have read, understood and agree to be bound by the Stripe terms and conditions which are available on their website.',
        '(b) You acknowledge and agree that where a request for the payment of the Subscription Fee is returned or denied, for whatever reason, by your financial institution or is unpaid by you for any other reason, then you are liable for any costs, including banking fees and charges, associated with the Subscription Fee.',
        '(c) You agree and acknowledge that SurpasIn Pty Ltd can vary the Subscription Fee at any time and that the varied Subscription Fee will come into effect following the conclusion of the existing Subscription Period.',
      ],
      className: '!font-normal',
      type: TYPOGRAPHY.PARA,
    },
  },
  {
    heading: {
      text: 'Refund Policy',
      className: '!font-semibold',
      type: TYPOGRAPHY.SUBTITLE,
    },
    description: {
      text: [
        '(a) SurpasIn Pty Ltd will only provide you with a refund of the Subscription Fee in the event they are unable to continue to provide the Services or if the manager of SurpasIn Pty Ltd makes a decision, at its absolute discretion, that it is reasonable to do so under the circumstances. Where this occurs, the refund will be in the proportional amount of the Subscription Fee that remains unused by the Member (Refund).',
        "(b) Any benefits set out in this Terms and Conditions may apply in addition to consumer's rights under the Australian Consumer Law.",
      ],
      className: '!font-normal',
      type: TYPOGRAPHY.PARA,
    },
  },
  {
    heading: {
      text: 'Copyright and Intellectual Property',
      className: '!font-semibold',
      type: TYPOGRAPHY.SUBTITLE,
    },
    description: {
      text: [
        '(a) The Website, the Services and all of the related products of SurpasIn Pty Ltd are subject to copyright. The material on the Website is protected by copyright under the laws of Australia and through international treaties. Unless otherwise indicated, all rights (including copyright) in the Services and compilation of the Website (including but not limited to text, graphics, logos, button icons, video images, audio clips, Website code, scripts, design elements and interactive features) or the Services are owned or controlled for these purposes, and are reserved by SurpasIn Pty Ltd or its contributors.',
        '(b) All trademarks, service marks and trade names are owned, registered and/or licensed by SurpasIn Pty Ltd, who grants to you a worldwide, non-exclusive, royalty-free, revocable license whilst you are a Member to:',
        '(i) use the Website pursuant to the Terms;',
        "(ii) copy and store the Website and the material contained in the Website in your device's cache memory; and",
        '(iii) print pages from the Website for your own personal and non-commercial use. SurpasIn Pty Ltd does not grant you any other rights whatsoever in relation to the Website or the Services. All other rights are expressly reserved by SurpasIn Pty Ltd.',
        '(c) SurpasIn Pty Ltd retains all rights, title and interest in and to the Website and all related Services. Nothing you do on or in relation to the Website will transfer any:',
        '(i) business name, trading name, domain name, trade mark, industrial design, patent, registered design or copyright, or',
        '(ii) a right to use or exploit a business name, trading name, domain name, trade mark or industrial design, or',
        '(iii) a thing, system or process that is the subject of a patent, registered design or copyright (or an adaptation or modification of such a thing, system or process).',
        '(d) You may not, without the prior written permission of SurpasIn Pty Ltd and the permission of any other relevant rights owners: broadcast, republish, up-load to a third party, transmit, post, distribute, show or play in public, adapt or change in any way the Services or third party Services for any purpose, unless otherwise provided by these Terms. This prohibition does not extend to materials on the Website, which are freely available for re-use or are in the public domain.',
      ],
      className: '!font-normal',
      type: TYPOGRAPHY.PARA,
    },
  },
  {
    heading: {
      text: 'Privacy',
      className: '!font-semibold',
      type: TYPOGRAPHY.SUBTITLE,
    },
    description: {
      text: "SurpasIn Pty Ltd takes your privacy seriously. All information provided through the Website is subject to SurpasIn Pty Ltd's Privacy Policy, available on the Website.",
      className: '!font-normal',
      type: TYPOGRAPHY.PARA,
    },
  },
  {
    heading: {
      text: 'General Disclaimer',
      className: '!font-semibold',
      type: TYPOGRAPHY.SUBTITLE,
    },
    description: {
      text: [
        '(a) Nothing in the Terms limits or excludes any guarantees, warranties, representations or conditions implied or imposed by law, including the Australian Consumer Law (or any liability under them) which by law may not be limited or excluded.',
        '(b) Subject to this clause, and to the extent permitted by law:',
        '(i) all terms, guarantees, warranties, representations or conditions which are not expressly stated in the Terms are excluded; and',
        '(ii) SurpasIn Pty Ltd will not be liable for any special, indirect or consequential loss or damage (unless such loss or damage is reasonably foreseeable resulting from our failure to meet an applicable Consumer Guarantee), loss of profit or opportunity, or damage to goodwill arising out of or in connection with the Services or these Terms (including as a result of not being able to use the Services or the late supply of the Services), whether at common law, under contract, tort (including negligence), in equity, pursuant to statute or otherwise.',
        '(c) Use of the Website and the Services is at your own risk. Everything on the Website and the Services is provided to you "as is" and "as available" without warranty or condition of any kind. None of the affiliates, directors, officers, employees, agents, contributors and licensors of SurpasIn Pty Ltd make any express or implied representation or warranty about the Services or any products or Services (including the products or Services of SurpasIn Pty Ltd) referred to on the Website. This includes (but is not restricted to) loss or damage you might suffer as a result of any of the following:',
        '(i) failure of performance, error, omission, interruption, deletion, defect, failure to correct defects, delay in operation or transmission, computer virus or other harmful component, loss of data, communication line failure, unlawful third party conduct, or theft, destruction, alteration or unauthorised access to records;',
        '(ii) the accuracy, suitability or currency of any information on the Website, the Services, or any of its Services related products (including third party material and advertisements on the Website);',
        '(iii) costs incurred as a result of you using the Website, the Services or any of the products of SurpasIn Pty Ltd; and',
        '(iv) the Services or operation in respect to links which are provided for your convenience.',
      ],
      className: '!font-normal',
      type: TYPOGRAPHY.PARA,
    },
  },
  {
    heading: {
      text: 'Limitation of Liability',
      className: '!font-semibold',
      type: TYPOGRAPHY.SUBTITLE,
    },
    description: {
      text: [
        "(a) SurpasIn Pty Ltd's total liability arising out of or in connection with the Services or these Terms, however arising, including under contract, tort (including negligence), in equity, under statute or otherwise, will not exceed the resupply of the Services to you.",
        '(b) You expressly understand and agree that SurpasIn Pty Ltd, its affiliates, employees, agents, contributors and licensors shall not be liable to you for any direct, indirect, incidental, special consequential or exemplary damages which may be incurred by you, however caused and under any theory of liability. This shall include, but is not limited to, any loss of profit (whether incurred directly or indirectly), any loss of goodwill or business reputation and any other intangible loss.',
      ],
      className: '!font-normal',
      type: TYPOGRAPHY.PARA,
    },
  },
  {
    heading: {
      text: 'Competitors',
      className: '!font-semibold',
      type: TYPOGRAPHY.SUBTITLE,
    },
    description: {
      text: "The Terms will apply until terminated by either party. You may terminate the Terms by providing SurpasIn Pty Ltd with 30 days' notice. SurpasIn Pty Ltd may terminate the Terms if you breach any provision of the Terms, if required by law, or if providing the Services is no longer commercially viable.",
      className: '!font-normal',
      type: TYPOGRAPHY.PARA,
    },
  },
  {
    heading: {
      text: 'Termination of Contract',
      className: '!font-semibold',
      type: TYPOGRAPHY.SUBTITLE,
    },
    description: {
      text: [
        '(a) The Terms will continue to apply until terminated by either you or by SurpasIn Pty Ltd as set out below',
        '(b) If you want to terminate the Terms, you may do so by:',
        "(i) providing SurpasIn Pty Ltd with 30 days' notice of your intention to terminate; and",
        '(ii) closing your accounts for all of the services which you use, where SurpasIn Pty Ltd has made this option available to you.',
        "Your notice should be sent, in writing, to SurpasIn Pty Ltd via the 'Contact Us' link on our homepage.",
        '(c) SurpasIn Pty Ltd may at any time, terminate the Terms with you if:',
        '(i) you have breached any provision of the Terms or intend to breach any provision;',
        '(ii) SurpasIn Pty Ltd is required to do so by law;',
        '(iii) the provision of the Services to you by SurpasIn Pty Ltd is, in the opinion of SurpasIn Pty Ltd, no longer commercially viable.',
        "(d) Subject to local applicable laws, SurpasIn Pty Ltd reserves the right to discontinue or cancel your membership at any time and may suspend or deny, in its sole discretion, your access to all or any portion of the Website or the Services without notice if you breach any provision of the Terms or any applicable law or if your conduct impacts SurpasIn Pty Ltd's name or reputation or violates the rights of those of another party.",
      ],
      className: '!font-normal',
      type: TYPOGRAPHY.PARA,
    },
  },
  {
    heading: {
      text: 'Indemnity',
      className: '!font-semibold',
      type: TYPOGRAPHY.SUBTITLE,
    },
    description: {
      text: [
        'You agree to indemnify SurpasIn Pty Ltd, its affiliates, employees, agents, contributors, third party content providers and licensors from and against:',
        '(a) all actions, suits, claims, demands, liabilities, costs, expenses, loss and damage (including legal fees on a full indemnity basis) incurred, suffered or arising out of or in connection with your content;',
        '(b) any direct or indirect consequences of you accessing, using or transacting on the Website or attempts to do so; and/or',
        '(c) any breach of the Terms.',
      ],
      className: '!font-normal',
      type: TYPOGRAPHY.PARA,
    },
  },
  {
    heading: {
      text: 'Compulsory',
      className: '!font-semibold',
      type: TYPOGRAPHY.SUBTITLE,
    },
    description: {
      text: ' If a dispute arises out of or relates to the Terms, either party may not commence any Tribunal or Court proceedings in relation to the dispute, unless the following clauses have been complied with (except where urgent interlocutory relief is sought) ',
      className: '!font-normal',
      type: TYPOGRAPHY.PARA,
    },
  },
  {
    heading: {
      text: 'Notice',
      className: '!font-semibold',
      type: TYPOGRAPHY.SUBTITLE,
    },
    description: {
      text: ' A party to the Terms claiming a dispute (Dispute) has arisen under the Terms, must give written notice to the other party detailing the nature of the dispute, the desired outcome and the action required to settle the Dispute ',
      className: '!font-normal',
      type: TYPOGRAPHY.PARA,
    },
  },
  {
    heading: {
      text: 'Resolution',
      className: '!font-semibold',
      type: TYPOGRAPHY.SUBTITLE,
    },
    description: {
      text: [
        ' On receipt of that notice (Notice) by that other party, the parties to the Terms (Parties) must',
        '(a)  Within 28 days of the Notice endeavour in good faith to resolve the Dispute expeditiously by negotiation or such other means upon which they may mutually agree;',
        '(b)  If for any reason whatsoever, 28 days after the date of the Notice, the Dispute has not been resolved, the Parties must either agree upon selection of a mediator or request that an appropriate mediator be appointed by the SurpasIn',
        '(c)  The Parties are equally liable for the fees and reasonable expenses of a mediator and the cost of the venue of the mediation and without limiting the foregoing undertake to pay any amounts requested by the mediator as a precondition to the mediation commencing. The Parties must each pay their own costs associated with the mediation',
        '(d)   The mediation will be held in Queensland, Australia',
      ],
      className: '!font-normal',
      type: TYPOGRAPHY.PARA,
    },
  },
  {
    heading: {
      text: ' Confidential',
      className: '!font-semibold',
      type: TYPOGRAPHY.SUBTITLE,
    },
    description: {
      text: 'All communications concerning negotiations made by the Parties arising out of and in connection with this dispute resolution clause are confidential and to the extent possible, must be treated as "without prejudice" negotiations for the purpose of applicable laws of evidence.',
      className: '!font-normal',
      type: TYPOGRAPHY.PARA,
    },
  },
  {
    heading: {
      text: ' Termination of Mediation',
      className: '!font-semibold',
      type: TYPOGRAPHY.SUBTITLE,
    },
    description: {
      text: ' If 2 months have elapsed after the start of a mediation of the Dispute and the Dispute has not been resolved, either Party may ask the mediator to terminate the mediation and the mediator must do so',
      className: '!font-normal',
      type: TYPOGRAPHY.PARA,
    },
  },
  {
    heading: {
      text: 'Venue and Jurisdiction',
      className: '!font-semibold',
      type: TYPOGRAPHY.SUBTITLE,
    },
    description: {
      text: 'The Services offered by SurpasIn Pty Ltd is intended to be viewed by residents of Australia. In the event of any dispute arising out of or in relation to the Website, you agree that the exclusive venue for resolving any dispute shall be in the courts of Queensland, Australia.',
      className: '!font-normal',
      type: TYPOGRAPHY.PARA,
    },
  },
  {
    heading: {
      text: 'Governing Law',
      className: '!font-semibold',
      type: TYPOGRAPHY.SUBTITLE,
    },
    description: {
      text: 'The Terms are governed by the laws of Queensland, Australia. Any dispute, controversy, proceeding or claim of whatever nature arising out of or in any way relating to the Terms and the rights created hereby shall be governed, interpreted and construed by, under and pursuant to the laws of Queensland, Australia, without reference to conflict of law principles, notwithstanding mandatory rules. The validity of this governing law clause is not contested. The Terms shall be binding to the benefit of the parties hereto and their successors and assigns',
      className: '!font-normal',
      type: TYPOGRAPHY.PARA,
    },
  },
  {
    heading: {
      text: 'Severance',
      className: '!font-semibold',
      type: TYPOGRAPHY.SUBTITLE,
    },
    description: {
      text: ' If any part of these Terms is found to be void or unenforceable by a Court of competent jurisdiction, that part shall be severed and the rest of the Terms shall remain in force.',
      className: '!font-normal',
      type: TYPOGRAPHY.PARA,
    },
  },
];
